module.exports = __webpack_public_path__ + "img/md-pin.2910968a.svg";